
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.828 5.258v7.304H5.61V6.298l-1.515 1.39v4.875H2.875V8.758L1.562 9.96l-.617-.688 1.93-1.68V.337h1.219V6.53l1.515-1.383V.336h1.22V4.14l1.32-1.258.609.687-1.93 1.688z","fill":"currentColor"}})])
          )
        }
      }
    